var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.08,
    height: 55.868,
    viewBox: "0 0 100.08 55.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6184",
    "data-name": "\\uC0AC\\uAC01\\uD615 6184",
    width: 100.08,
    height: 55.868,
    transform: "translate(0 0)",
    fill: "#797979"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_59245",
    "data-name": "\\uADF8\\uB8F9 59245",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_59244",
    "data-name": "\\uADF8\\uB8F9 59244",
    transform: "translate(0 -0.003)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34119",
    "data-name": "\\uD328\\uC2A4 34119",
    d: "M44.8,36.836a23.025,23.025,0,1,1,2.447-17.9h2.067a25.041,25.041,0,0,0-47.343-3.65A25.035,25.035,0,0,0,47.1,36.836Z",
    transform: "translate(0 0.003)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_315",
    "data-name": "\\uC120 315",
    y2: 38.416,
    transform: "translate(98.797 17.452)",
    fill: "#a88720"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6182",
    "data-name": "\\uC0AC\\uAC01\\uD615 6182",
    width: 2.565,
    height: 38.416,
    transform: "translate(97.515 17.452)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34120",
    "data-name": "\\uD328\\uC2A4 34120",
    d: "M939.343,716.555l1.143-.113a3.117,3.117,0,0,0,.378,1.281,2.134,2.134,0,0,0,.92.81,3.156,3.156,0,0,0,1.4.306,3,3,0,0,0,1.223-.233,1.74,1.74,0,0,0,.79-.642,1.629,1.629,0,0,0,.259-.89,1.476,1.476,0,0,0-.25-.855,1.839,1.839,0,0,0-.823-.614,14.467,14.467,0,0,0-1.63-.506,7.78,7.78,0,0,1-1.766-.649,2.51,2.51,0,0,1-1.3-2.264,2.91,2.91,0,0,1,.392-1.472,2.516,2.516,0,0,1,1.15-1.039,3.908,3.908,0,0,1,1.678-.355,4.09,4.09,0,0,1,1.794.373,2.68,2.68,0,0,1,1.2,1.094,3.47,3.47,0,0,1,.45,1.64l-1.161.1a1.97,1.97,0,0,0-2.228-1.994,2.33,2.33,0,0,0-1.6.458,1.44,1.44,0,0,0-.5,1.1,1.257,1.257,0,0,0,.355.923,4.516,4.516,0,0,0,1.827.742,11.1,11.1,0,0,1,2.026.664,2.7,2.7,0,0,1,1.561,2.539,3.125,3.125,0,0,1-.419,1.563,2.873,2.873,0,0,1-1.2,1.144,3.772,3.772,0,0,1-1.763.408,4.723,4.723,0,0,1-2.083-.411,3.043,3.043,0,0,1-1.314-1.24,3.815,3.815,0,0,1-.5-1.869",
    transform: "translate(-890.833 -672.69)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34121",
    "data-name": "\\uD328\\uC2A4 34121",
    d: "M1101.555,768.869a4.177,4.177,0,0,1,1.024-3.1,2.872,2.872,0,0,1,2.086-.838,2.8,2.8,0,0,1,2.235,1.019,4.2,4.2,0,0,1,.866,2.811,5.527,5.527,0,0,1-.385,2.288,2.958,2.958,0,0,1-2.716,1.755,2.8,2.8,0,0,1-2.252-1.013,4.409,4.409,0,0,1-.858-2.923m1.156,0a3.523,3.523,0,0,0,.554,2.167,1.711,1.711,0,0,0,2.791,0,3.607,3.607,0,0,0,.556-2.205,3.428,3.428,0,0,0-.559-2.118,1.713,1.713,0,0,0-2.788,0,3.51,3.51,0,0,0-.554,2.164",
    transform: "translate(-1044.668 -725.428)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_6183",
    "data-name": "\\uC0AC\\uAC01\\uD615 6183",
    width: 1.124,
    height: 10.4,
    transform: "translate(64.39 36.809)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34122",
    "data-name": "\\uD328\\uC2A4 34122",
    d: "M1306.189,775.776v-1.108a2.359,2.359,0,0,1-2.1,1.277,2.422,2.422,0,0,1-1.1-.254,1.842,1.842,0,0,1-.754-.642,2.551,2.551,0,0,1-.346-.947,7.238,7.238,0,0,1-.071-1.192v-4.667h1.124v4.179a8.473,8.473,0,0,0,.069,1.348,1.368,1.368,0,0,0,.45.791,1.28,1.28,0,0,0,.85.285,1.663,1.663,0,0,0,.947-.294,1.581,1.581,0,0,0,.629-.8,4.516,4.516,0,0,0,.184-1.472v-4.035h1.125v7.534Z",
    transform: "translate(-1234.59 -728.568)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34123",
    "data-name": "\\uD328\\uC2A4 34123",
    d: "M1431.091,726.286l.162,1.129a3.722,3.722,0,0,1-.848.112,1.748,1.748,0,0,1-.95-.218,1.212,1.212,0,0,1-.475-.579,5.22,5.22,0,0,1-.137-1.509v-4.332h-.823V719.9h.823V718.03l1.118-.767V719.9h1.131v.994h-1.131v4.4a2.481,2.481,0,0,0,.06.7.514.514,0,0,0,.194.248.678.678,0,0,0,.385.092,3.249,3.249,0,0,0,.492-.049",
    transform: "translate(-1354.272 -680.221)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34124",
    "data-name": "\\uD328\\uC2A4 34124",
    d: "M1508.919,712.755h1.122v1.467h-1.122Zm0,2.866h1.122v7.534h-1.122Z",
    transform: "translate(-1430.994 -675.946)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34125",
    "data-name": "\\uD328\\uC2A4 34125",
    d: "M1555.678,768.869a4.177,4.177,0,0,1,1.024-3.1,2.87,2.87,0,0,1,2.086-.838,2.805,2.805,0,0,1,2.234,1.019,4.189,4.189,0,0,1,.867,2.811,5.55,5.55,0,0,1-.385,2.288,2.928,2.928,0,0,1-1.117,1.295,2.959,2.959,0,0,1-1.6.46,2.8,2.8,0,0,1-2.251-1.013,4.414,4.414,0,0,1-.858-2.923m1.156,0a3.514,3.514,0,0,0,.556,2.167,1.71,1.71,0,0,0,2.79,0,3.613,3.613,0,0,0,.555-2.205,3.419,3.419,0,0,0-.559-2.118,1.71,1.71,0,0,0-2.786,0,3.5,3.5,0,0,0-.556,2.164",
    transform: "translate(-1475.338 -725.428)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34126",
    "data-name": "\\uD328\\uC2A4 34126",
    d: "M1701.486,772.636V765.1h1.01v1.07a2.319,2.319,0,0,1,2.111-1.241,2.491,2.491,0,0,1,1.1.245,1.79,1.79,0,0,1,.752.642,2.651,2.651,0,0,1,.348.944,7.916,7.916,0,0,1,.064,1.241v4.633h-1.124v-4.584a3.9,3.9,0,0,0-.131-1.167,1.18,1.18,0,0,0-.466-.615,1.343,1.343,0,0,0-.782-.231,1.707,1.707,0,0,0-1.241.517,2.791,2.791,0,0,0-.52,1.966v4.115Z",
    transform: "translate(-1613.616 -725.428)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34127",
    "data-name": "\\uD328\\uC2A4 34127",
    d: "M356.393,344.863h6.3l2.429,9.432,2.412-9.432h6.3v15.5h-3.923V348.543l-3.023,11.822h-3.551l-3.017-11.822v11.822h-3.923Z",
    transform: "translate(-337.988 -327.053)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34128",
    "data-name": "\\uD328\\uC2A4 34128",
    d: "M737.447,428.57a5.618,5.618,0,0,1,1.734-4.235,7.523,7.523,0,0,1,9.781.291,6.116,6.116,0,0,1-.333,8.126,6.567,6.567,0,0,1-4.753,1.655,6.668,6.668,0,0,1-4.378-1.375,5.518,5.518,0,0,1-2.051-4.462m4.314-.011a3.388,3.388,0,0,0,.608,2.221,1.992,1.992,0,0,0,3.056.011,3.5,3.5,0,0,0,.6-2.273,3.31,3.31,0,0,0-.6-2.173,1.877,1.877,0,0,0-1.491-.714,1.949,1.949,0,0,0-1.554.724,3.352,3.352,0,0,0-.613,2.2",
    transform: "translate(-699.363 -400.842)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34129",
    "data-name": "\\uD328\\uC2A4 34129",
    d: "M1029.3,344.863v15.5h-4.029V358.7a5.417,5.417,0,0,1-1.544,1.428,4.407,4.407,0,0,1-2.073.486,4,4,0,0,1-3.505-1.745,7.252,7.252,0,0,1-1.211-4.24,6.164,6.164,0,0,1,1.338-4.272,4.381,4.381,0,0,1,3.4-1.48,4.739,4.739,0,0,1,1.824.338,4.152,4.152,0,0,1,1.454,1.015v-5.372Zm-4.314,9.855a2.96,2.96,0,0,0-.56-1.972,1.79,1.79,0,0,0-1.417-.65,1.562,1.562,0,0,0-1.258.624,3.353,3.353,0,0,0-.508,2.094,3.162,3.162,0,0,0,.523,2.014,1.611,1.611,0,0,0,1.3.64,1.733,1.733,0,0,0,1.375-.645,3.231,3.231,0,0,0,.55-2.1",
    transform: "translate(-964.424 -327.053)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34130",
    "data-name": "\\uD328\\uC2A4 34130",
    d: "M1296.845,428.57a5.618,5.618,0,0,1,1.734-4.235,7.523,7.523,0,0,1,9.781.291,6.115,6.115,0,0,1-.333,8.126,6.567,6.567,0,0,1-4.753,1.655,6.669,6.669,0,0,1-4.378-1.375,5.518,5.518,0,0,1-2.051-4.462m4.314-.011a3.388,3.388,0,0,0,.608,2.221,1.992,1.992,0,0,0,3.056.011,3.5,3.5,0,0,0,.6-2.273,3.31,3.31,0,0,0-.6-2.173,1.877,1.877,0,0,0-1.491-.714,1.949,1.949,0,0,0-1.555.724,3.352,3.352,0,0,0-.613,2.2",
    transform: "translate(-1229.872 -400.842)",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34131",
    "data-name": "\\uD328\\uC2A4 34131",
    d: "M1576.543,428.57a5.618,5.618,0,0,1,1.734-4.235,7.523,7.523,0,0,1,9.781.291,6.116,6.116,0,0,1-.333,8.126,6.568,6.568,0,0,1-4.753,1.655,6.668,6.668,0,0,1-4.378-1.375,5.518,5.518,0,0,1-2.052-4.462m4.314-.011a3.387,3.387,0,0,0,.608,2.221,1.992,1.992,0,0,0,3.056.011,3.5,3.5,0,0,0,.6-2.273,3.311,3.311,0,0,0-.6-2.173,1.877,1.877,0,0,0-1.491-.714,1.949,1.949,0,0,0-1.554.724,3.352,3.352,0,0,0-.613,2.2",
    transform: "translate(-1495.126 -400.842)",
    fill: "#797979"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.06494bd844d77be74600004b55fe2120.svg";
export { ForwardRef as ReactComponent };